import React, {
  useEffect,
  useRef,
  useContext,
  useState,
  useLayoutEffect,
  memo,
  useCallback,
} from "react";
import Drawer from "@material-ui/core/Drawer";

import { callApi, serializeObject } from "bodycodi/cmap/app/js/common";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { observerType } from "bodycodi/cmap/app/components/common/useObserver";
import Condition from "bodycodi/cmap/app/components/cmap3010/condition";
import MemberSearchPop from "bodycodi/cmap/app/components/cmap2040/choosememberPass/memberSearchPop";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";
import { Members } from "bodycodi/cmap/app/type";
import MemberList from "bodycodi/cmap/app/components/common/MemberList";

type ChooseMemberPassPopProp = {
  scheduleType: string;
  member: any;
  setMember: Function;
  setStep: Function;
  children: any;
};
type ChooseMemberPassPop = {
  member: any;
  setMember: Function;
  children: any;
};
export interface State extends observerType {
  tabName: "APPOINTMENT" | "CHARGE" | "ENTRANCE";
  isDone: boolean;
  isScrollEnd: boolean;
}

const ChooseMemberPassPopWrap = ({
  setMember,
  setStep,
  children,
  member,
  scheduleType,
}: ChooseMemberPassPopProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (scheduleType === "OT") {
      setTitle("OT 스케줄 예약");
    } else if (scheduleType === "CS") {
      setTitle("상담 스케줄 예약");
    }
  }, [scheduleType]);

  const handleClose = useCallback(() => {
    dispatch({ type: "CLOSE_ALL_POP" });
  }, []);

  return (
    <Drawer
      anchor="bottom"
      open={state.chooseMemberPop}
      onClose={handleClose}
      className="picker-pop max"
    >
      <PickerHeader title={title} onClose={handleClose} />
      {state.chooseMemberPop && (
        <ChooseMemberPassPop member={member} setMember={setMember}>
          {children}
        </ChooseMemberPassPop>
      )}
    </Drawer>
  );
};

const ChooseMemberPassPop = ({ setMember, children, member }: ChooseMemberPassPop) => {
  const { seqPartner, seqPartnerBranch, seqPartnerCoach } = useSelector(
    (state: RootState) => state.partner
  );
  const form = useRef<HTMLDivElement>(null);

  const [isSearch, setIsSearch] = useState<boolean>(false);

  const [members, setMembers] = useState<Members>({
    appointmentMemberTotalCount: 0,
    chargeMemberTotalCount: 0,
    entranceMemberTotalCount: 0,
    memberList: [],
  });
  const [state, setState] = useState<State>({
    tabName: "APPOINTMENT",
    pageNo: 0,
    listSize: 10,
    loading: false,
    first: true,
    isDone: false,
    isScrollEnd: false,
  });
  const { tabName, pageNo, listSize } = state;

  useLayoutEffect(() => {
    setState((previousValue: State) => ({
      ...previousValue,
      loading: true,
    }));
    fetchMembers("fetch");
  }, [seqPartner, seqPartnerBranch, seqPartnerCoach, tabName]);

  const fetchMembers = (type: string, isReset = false) => {
    setState((previousValue: State) => ({
      ...previousValue,
      loading: true,
    }));
    const data: any = serializeObject({ element: form.current });
    callApi(
      "/members",
      {
        seqPartner: seqPartner,
        seqPartnerBranch: seqPartnerBranch,
        seqPartnerCoach: seqPartnerCoach,
        memberListType: type === "search" ? "" : isReset ? "APPOINTMENT" : tabName,
        keyword: isReset ? "" : data.name,
        pageNo: isReset ? 0 : pageNo,
        rowAmt: listSize,
      },
      "GET"
    )
      .then((res) => {
        if (type === "add") {
          setMembers((previousValue: Members) => ({
            ...previousValue,
            memberList: previousValue.memberList.concat(res.memberList),
          }));
        } else {
          setMembers(res);
        }
        if (res.memberList.length < listSize) {
          setState((previousValue: State) => ({
            ...previousValue,
            pageNo: 0,
            isDone: true,
            tabName: isReset ? "APPOINTMENT" : previousValue.tabName,
            isScrollEnd: true,
          }));
        } else {
          setState((previousValue: State) => ({
            ...previousValue,
            pageNo: previousValue.pageNo + previousValue.listSize,
            isDone: false,
            tabName: isReset ? "APPOINTMENT" : previousValue.tabName,
          }));
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setState((previousValue: State) => ({
          ...previousValue,
          loading: false,
          first: false,
        }));
      });
  };

  const handleClickTab = (tabName: "APPOINTMENT" | "CHARGE" | "ENTRANCE") => {
    setMembers((previousValue: Members) => ({
      ...previousValue,
      memberList: [],
    }));
    setState((previousValue: State) => ({
      ...previousValue,
      tabName,
      pageNo: 0,
      first: true,
      isDone: false,
      isScrollEnd: false,
    }));
  };

  return (
    <div className="picker-body choose-schedule-pop add-schedule-pop-wrap">
      <div className="add-schedule-pop">
        <div className="title margin">회원님 선택</div>
        <div className="member-mngt-wrap" ref={form}>
          <MemberSearchPop
            fetchMembers={fetchMembers}
            setIsSearch={setIsSearch}
            setMember={setMember}
          />
          {!isSearch && (
            <Condition
              tabName={tabName}
              appointmentMemberTotalCount={members.appointmentMemberTotalCount}
              chargeMemberTotalCount={members.chargeMemberTotalCount}
              entranceMemberTotalCount={members.entranceMemberTotalCount}
              onClickTab={handleClickTab}
            />
          )}
          <MemberList
            memberList={members.memberList}
            scrollEnd={state.isScrollEnd}
            loading={state.loading}
            listSize={state.listSize}
            isDone={state.isDone}
            isBan={false}
            fetchMembers={fetchMembers}
            from="schedule"
            onClickMember={setMember}
            chooseMemberList={{ [member.seqMember]: member }}
          />
        </div>
      </div>
      {children}
    </div>
  );
};

export default memo(ChooseMemberPassPopWrap);
